<template>
    <textarea
            ref="textarea"
            :value="value"
            @focus="onFocus"
            @blur="onBlur"
            @input="onInput"
            :style="{height: height, 'min-height': minHeight}"></textarea>
</template>

<script>
    export default {
        name: 'AutoHeightTextarea',
        props: {
            value: {
                default: '',
            },
            minHeight: {
                default: '200px'
            },
            focus: {
                default: false,
            }
        },
        data() {
            return {
                isFocus: false,
            };
        },
        computed: {
            height() {
                if (! this.isFocus || ! this.value) {
                    return '2em';
                }

                let height = this.value.split('\n').length + 2;

                return `${height * 1.3}em`;
            },
        },
        methods: {
            onFocus() {
                this.isFocus = true;
                this.$emit('onFocus', true);
            },
            onBlur() {
                this.isFocus = false;
            },
            onInput(e) {
                this.$emit('input', e.target.value)
            },
        },
        mounted() {
            if (this.focus) {
                this.$refs.textarea.focus();
            }
        }
    };
</script>

<style scoped>
    textarea {
        width: 100%;
        padding: 0;
        border: none;
        font-size: 14px;
        line-height: 20px;
        resize: none;
        transition: height 0.1s;
    }

    @media screen and (max-height: 670px) {
        textarea {
            width: 100%;
            min-height: 100px;
            padding: 0;
            border: none;
        }
    }
</style>
